import React, { useState, useEffect } from "react";
import { Card, Table, Badge, Pagination } from "react-bootstrap";
import Content from "../../../Components/Dashboard/Content/Content.jsx";
import {
  getCoinDCXBalance,
  getCoincdxPosition,
  getCoincdxTransactiondata,
  getCoinDCXHoldingsdata,
  BrokerBinanceOpenPositiondata,
  BrokerBinanceAccount,
  BrokerBinanceSpotAccount,
  brokerBinanceHoldingPositionData,
  UserDirectExit,
} from "../../../Service/Broker.service.jsx";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const Binance = () => {
  const dispatch = useDispatch();

  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );

  const [walletdata, setWalletdata] = useState([]);
  const [walletspotdata, setWalletspotdata] = useState([]);
  const [positiondata, setPositiondata] = useState([]);
  const [Holding, setHolding] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState({
    wallet: false,
    positions: false,
    transactions: false,
    exit: false,
  });
  const [activeTab, setActiveTab] = useState("Future");
  const [showActivePositions, setShowActivePositions] = useState(true);

  const [walletPagination, setWalletPagination] = useState({
    currentPage: 1,
    itemsPerPage: 5,
  });
  const [positionPagination, setPositionPagination] = useState({
    currentPage: 1,
    itemsPerPage: 5,
  });
  const [transactionPagination, setTransactionPagination] = useState({
    currentPage: 1,
    itemsPerPage: 5,
  });

  useEffect(() => {
    if (activeTab === "Future") {
      getWallet();
      getPosition();
      getHolding();
    } else if (activeTab === "Spot") {
      getSpotWallet();
    }
    // getTransaction();
  }, [activeTab]);

  const getWallet = async () => {
    try {
      const data = {
        _id: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await BrokerBinanceAccount(data);
      if (response.status) {
        setWalletdata(response?.data || []);
      } else {
        setWalletdata([]);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch wallet data. Please try again later.",
      });
    }
  };

  const getSpotWallet = async () => {
    try {
      const data = {
        _id: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await BrokerBinanceSpotAccount(data);
      if (response.status) {
        setWalletspotdata(response?.data?.balances || []);
      } else {
        setWalletspotdata([]);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch spot wallet data. Please try again later.",
      });
    }
  };

  const getPosition = async () => {
    try {
      const data = {
        _id: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await BrokerBinanceOpenPositiondata(data);
      if (response.status) {
        setPositiondata(response?.data);
      } else {
        setPositiondata([]);
      }
    } catch (error) {}
  };

  const getHolding = async () => {
    try {
      const data = {
        _id: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await brokerBinanceHoldingPositionData(data);

      if (response.status) {
        setHolding(response?.data);
      } else {
        setHolding([]);
      }
    } catch (error) {}
  };

  // Pagination helper functions
  const paginateData = (data, currentPage, itemsPerPage) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data?.slice(startIndex, endIndex);
  };

  const getTotalPages = (totalItems, itemsPerPage) => {
    return Math.ceil(totalItems / itemsPerPage);
  };

  const calculateTotals = () => {
    let data = [];

    if (activeTab === "Future") {
      data = walletdata;
    } else {
      data = walletspotdata;
    }

    if (!Array.isArray(data) || data.length === 0) {
      return {
        totalBalance: "0.00",
        totalLockedBalance: "0.00",
        currencies: 0,
      };
    }

    const totalBalance = data.reduce(
      (sum, item) => sum + parseFloat(item.walletBalance || item.free || 0),
      0
    );
    const totalLockedBalance = data.reduce(
      (sum, item) => sum + parseFloat(item.locked || 0),
      0
    );

    return {
      totalBalance: totalBalance,
      totalLockedBalance: totalLockedBalance,
      currencies: data.length,
    };
  };

  const renderPagination = (currentPage, totalPages, onPageChange) => {
    if (totalPages <= 1) return null;

    const items = [];
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => onPageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    return (
      <div className="d-flex justify-content-center mt-3">
        <Pagination size="sm">
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          />
          {items}
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  // Get paginated data based on active tab
  const getCurrentWalletData = () => {
    if (activeTab === "Future") {
      return paginateData(
        walletdata,
        walletPagination.currentPage,
        walletPagination.itemsPerPage
      );
    } else {
      return paginateData(
        walletspotdata,
        walletPagination.currentPage,
        walletPagination.itemsPerPage
      );
    }
  };

  const activePositions = positiondata.filter((item) => showActivePositions);

  const paginatedPositionData = paginateData(
    activePositions,
    positionPagination.currentPage,
    positionPagination.itemsPerPage
  );

  const holdingdata = paginateData(
    activePositions.filter((item) => item.active_pos > 0),
    positionPagination.currentPage,
    positionPagination.itemsPerPage
  );

  const paginatedTransactionData = paginateData(
    transactions,
    transactionPagination.currentPage,
    transactionPagination.itemsPerPage
  );

  const totals = calculateTotals();

  return (
    <div className="wallet-container">
      <div className="container-fluid">
        <div className="container mt-4 mb-2 d-flex justify-content-center">
          <ul className="nav nav-tabs shadow-sm rounded w-100">
            <li className="nav-item text-center">
              <button
                className={`nav-link ${
                  activeTab === "Future" ? "active fw-bold text-primary" : ""
                }`}
                onClick={() => setActiveTab("Future")}
              >
                <i className="bi bi-bag-check "></i> Future Trading
              </button>
            </li>
            {/* <li className="nav-item text-center">
                            <button
                                className={`nav-link ${activeTab === "Spot" ? "active fw-bold text-primary" : ""
                                    }`}
                                onClick={() => setActiveTab("Spot")}
                            >
                                <i className="bi bi-cart-check "></i> Spot Trading
                            </button>
                        </li> */}
          </ul>
        </div>

        <>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h5 className="mb-1">
                <i
                  className="fas fa-wallet me-2"
                  style={{ color: "#3498db" }}
                ></i>
                {activeTab} Portfolio Overview
              </h5>
              <p className=" mb-0">
                Manage your crypto assets and trading positions
              </p>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-4 mb-3">
              <Card
                className="h-100 shadow-sm border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                <Card.Body className="text-white text-center">
                  <div className="mb-2 pt-2">
                    <i
                      className="fas fa-coins fa-2x "
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                  <h3 className="fw-bold mb-1">{totals.currencies}</h3>
                  <h6 className="opacity-75 mb-0">Total Currencies</h6>
                  <small className="opacity-50">Active Holdings</small>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4 mb-3">
              <Card
                className="h-100 shadow-sm border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                }}
              >
                <Card.Body className="text-white text-center">
                  <div className="mb-2 pt-2">
                    <i
                      className="fas fa-chart-line fa-2x text-white"
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                  <h3 className="fw-bold mb-1">
                    {parseFloat(totals.totalBalance || 0).toFixed(4)}
                  </h3>
                  <h6 className="opacity-75 mb-0">Total Balance</h6>
                  <small className="opacity-50">Combined Balance</small>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-4 mb-3">
              <Card
                className="h-100 shadow-sm border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                }}
              >
                <Card.Body className="text-white text-center">
                  <div className="mb-2 pt-2">
                    <i
                      className="fas fa-lock fa-2x text-white"
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                  <h3 className="fw-bold mb-1">{totals.totalLockedBalance}</h3>
                  <h6 className="opacity-75 mb-0">Total Locked</h6>
                  <small className="opacity-50">Locked Balance</small>
                </Card.Body>
              </Card>
            </div>
          </div>

          <Card className="shadow-sm border-0 mb-4">
            <Card.Header className=" border-bottom-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1">
                    <i
                      className="fas fa-wallet me-2"
                      style={{ color: "#e74c3c" }}
                    ></i>
                    {activeTab} Wallet Details
                  </h5>
                  <small className="">Your cryptocurrency holdings</small>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              {getCurrentWalletData().length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-inbox fa-3x  mb-3"></i>
                  <p className=" mb-0">No wallet data available.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          <th className="border-0 py-3 px-4">#</th>
                          <th className="border-0 py-3">Currency</th>
                          {activeTab === "Future" ? (
                            <>
                              <th className="border-0 py-3">Wallet Balance</th>
                              <th className="border-0 py-3">Unrealized PnL</th>
                              <th className="border-0 py-3">Margin Balance</th>
                              <th className="border-0 py-3">Initial Margin</th>
                              <th className="border-0 py-3">Maint. Margin</th>
                              <th className="border-0 py-3">
                                Available Balance
                              </th>
                              <th className="border-0 py-3">Withdrawable</th>
                            </>
                          ) : (
                            <>
                              <th className="border-0 py-3">Free</th>
                              <th className="border-0 py-3">Locked</th>
                            </>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {getCurrentWalletData().map((wallet, index) => {
                          const globalIndex =
                            (walletPagination.currentPage - 1) *
                              walletPagination.itemsPerPage +
                            index +
                            1;

                          return (
                            <tr key={index}>
                              <td className="py-3 px-4 border-0">
                                <span className="badge bg-light text-dark">
                                  {globalIndex}
                                </span>
                              </td>

                              <td className="py-3 border-0 fw-bold">
                                {wallet.asset}
                              </td>

                              {activeTab === "Future" ? (
                                <>
                                  <td className="py-3 border-0 fw-bold text-primary">
                                    {parseFloat(
                                      wallet.walletBalance || 0
                                    ).toFixed(4)}
                                  </td>
                                  <td
                                    className="py-3 border-0 fw-bold"
                                    style={{
                                      color:
                                        parseFloat(wallet.unrealizedProfit) >= 0
                                          ? "green"
                                          : "red",
                                    }}
                                  >
                                    {parseFloat(
                                      wallet.unrealizedProfit || 0
                                    ).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0">
                                    {parseFloat(
                                      wallet.marginBalance || 0
                                    ).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0">
                                    {parseFloat(
                                      wallet.initialMargin || 0
                                    ).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0">
                                    {parseFloat(
                                      wallet.maintMargin || 0
                                    ).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0 fw-bold text-success">
                                    {parseFloat(
                                      wallet.availableBalance || 0
                                    ).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0 fw-bold text-warning">
                                    {parseFloat(
                                      wallet.maxWithdrawAmount || 0
                                    ).toFixed(4)}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td className="py-3 border-0 fw-bold text-primary">
                                    {parseFloat(wallet.free || 0).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0 fw-bold text-warning">
                                    {parseFloat(wallet.locked || 0).toFixed(4)}
                                  </td>
                                </>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {renderPagination(
                    walletPagination.currentPage,
                    getTotalPages(
                      activeTab === "Future"
                        ? walletdata.length
                        : walletspotdata.length,
                      walletPagination.itemsPerPage
                    ),
                    (page) =>
                      setWalletPagination((prev) => ({
                        ...prev,
                        currentPage: page,
                      }))
                  )}
                </>
              )}
            </Card.Body>
          </Card>

          {activeTab === "Future" && (
            <>
              <Card className="shadow-sm border-0 mb-4">
                <Card.Header className=" border-bottom-0 py-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="d-flex gap-3 align-items-center mb-1">
                        <h5 className="mb-1">
                          <i
                            className="fas fa-chart-bar me-2"
                            style={{ color: "#f39c12" }}
                          ></i>
                          Future Positions
                        </h5>
                      </div>
                      <small className="">Your current trading positions</small>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  {activePositions.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="fas fa-chart-line fa-3x mb-3"></i>
                      <p className="mb-0">No positions available.</p>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead style={{ backgroundColor: "#f8f9fa" }}>
                            <tr>
                              <th className="border-0 py-3 px-4">#</th>
                              <th className="border-0 py-3">Symbol</th>
                              <th className="border-0 py-3">Market Price</th>
                              <th className="border-0 py-3">Entry Price</th>
                              <th className="border-0 py-3">Leverage</th>
                              <th className="border-0 py-3">Notional</th>
                              <th className="border-0 py-3">Size</th>
                              <th className="border-0 py-3">
                                P&L (Unrealized)
                              </th>
                              <th className="border-0 py-3">Liq. Price</th>
                              <th className="border-0 py-3">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedPositionData.map((position, index) => {
                              const globalIndex =
                                (positionPagination.currentPage - 1) *
                                  positionPagination.itemsPerPage +
                                index +
                                1;

                              const isLong =
                                parseFloat(position.positionAmt) > 0;

                              return (
                                <tr key={index} className="border-0">
                                  <td className="py-3 px-4 border-0">
                                    <span className="badge bg-light text-dark">
                                      {globalIndex}
                                    </span>
                                  </td>
                                  <td className="py-3 border-0 fw-bold">
                                    {position.symbol}
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    ${parseFloat(position.markPrice).toFixed(6)}
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    $
                                    {parseFloat(position.entryPrice).toFixed(6)}
                                  </td>
                                  <td className="py-3 border-0">
                                    <Badge bg="info" className="px-2 py-1">
                                      {position.leverage}x
                                    </Badge>
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    ${parseFloat(position.notional).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0">
                                    <Badge
                                      bg={isLong ? "success" : "danger"}
                                      className="px-3 py-2"
                                    >
                                      <i
                                        className={`fas ${
                                          isLong
                                            ? "fa-arrow-up"
                                            : "fa-arrow-down"
                                        } me-1`}
                                      ></i>
                                      {parseFloat(position.positionAmt).toFixed(
                                        2
                                      )}
                                    </Badge>
                                  </td>
                                  <td
                                    className={`py-3 border-0 fw-medium ${
                                      parseFloat(position.unRealizedProfit) >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }`}
                                  >
                                    $
                                    {parseFloat(
                                      position.unRealizedProfit
                                    ).toFixed(6)}
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    $
                                    {parseFloat(
                                      position.liquidationPrice
                                    ).toFixed(6)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      {renderPagination(
                        positionPagination.currentPage,
                        getTotalPages(
                          Holding.length,
                          positionPagination.itemsPerPage
                        ),
                        (page) =>
                          setPositionPagination((prev) => ({
                            ...prev,
                            currentPage: page,
                          }))
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </>
          )}

          {activeTab === "Future" && (
            <>
              <Card className="shadow-sm border-0 mb-4">
                <Card.Header className=" border-bottom-0 py-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="d-flex gap-3 align-items-center mb-1">
                        <h5 className="mb-1">
                          <i
                            className="fas fa-chart-bar me-2"
                            style={{ color: "#f39c12" }}
                          ></i>
                          Future Holding Positions
                        </h5>
                      </div>
                      <small className="">Your current trading positions</small>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  {Holding.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="fas fa-chart-line fa-3x mb-3"></i>
                      <p className="mb-0">No positions available.</p>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead style={{ backgroundColor: "#f8f9fa" }}>
                            <tr>
                              <th className="border-0 py-3 px-4">#</th>
                              <th className="border-0 py-3">Symbol</th>
                              <th className="border-0 py-3">Market Price</th>
                              <th className="border-0 py-3">Entry Price</th>
                              <th className="border-0 py-3">Leverage</th>
                              <th className="border-0 py-3">Notional</th>
                              <th className="border-0 py-3">Size</th>
                              <th className="border-0 py-3">
                                P&L (Unrealized)
                              </th>
                              <th className="border-0 py-3">Liq. Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Holding.map((position, index) => {
                              const globalIndex =
                                (positionPagination.currentPage - 1) *
                                  positionPagination.itemsPerPage +
                                index +
                                1;

                              const isLong =
                                parseFloat(position.positionAmt) > 0;

                              return (
                                <tr key={index} className="border-0">
                                  <td className="py-3 px-4 border-0">
                                    <span className="badge bg-light text-dark">
                                      {globalIndex}
                                    </span>
                                  </td>
                                  <td className="py-3 border-0 fw-bold">
                                    {position.symbol}
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    ${parseFloat(position.markPrice).toFixed(6)}
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    $
                                    {parseFloat(position.entryPrice).toFixed(6)}
                                  </td>
                                  <td className="py-3 border-0">
                                    <Badge bg="info" className="px-2 py-1">
                                      {position.leverage}x
                                    </Badge>
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    ${parseFloat(position.notional).toFixed(4)}
                                  </td>
                                  <td className="py-3 border-0">
                                    <Badge
                                      bg={isLong ? "success" : "danger"}
                                      className="px-3 py-2"
                                    >
                                      <i
                                        className={`fas ${
                                          isLong
                                            ? "fa-arrow-up"
                                            : "fa-arrow-down"
                                        } me-1`}
                                      ></i>
                                      {parseFloat(position.positionAmt).toFixed(
                                        2
                                      )}
                                    </Badge>
                                  </td>
                                  <td
                                    className={`py-3 border-0 fw-medium ${
                                      parseFloat(position.unRealizedProfit) >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }`}
                                  >
                                    $
                                    {parseFloat(
                                      position.unRealizedProfit
                                    ).toFixed(6)}
                                  </td>
                                  <td className="py-3 border-0 fw-medium">
                                    $
                                    {parseFloat(
                                      position.liquidationPrice
                                    ).toFixed(6)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      {renderPagination(
                        positionPagination.currentPage,
                        getTotalPages(
                          Holding.length,
                          positionPagination.itemsPerPage
                        ),
                        (page) =>
                          setPositionPagination((prev) => ({
                            ...prev,
                            currentPage: page,
                          }))
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </>
          )}

         
        </>
      </div>
    </div>
  );
};

export default Binance;
